// Currency utility functions

export const currencies = [
  { code: 'PLN', name: 'Polish Złoty', symbol: 'zł' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'USD', name: 'US Dollar', symbol: '$' }
];

// Get current selected currency from localStorage
export const getCurrentCurrency = () => {
  return localStorage.getItem('warehouse_currency') || 'EUR';
};

// Get currency symbol
export const getCurrencySymbol = (currencyCode = null) => {
  const code = currencyCode || getCurrentCurrency();
  const currency = currencies.find(c => c.code === code);
  return currency ? currency.symbol : '€';
};

// Get currency name
export const getCurrencyName = (currencyCode = null) => {
  const code = currencyCode || getCurrentCurrency();
  const currency = currencies.find(c => c.code === code);
  return currency ? currency.name : 'Euro';
};

// Format price with currency
export const formatPrice = (amount, currencyCode = null) => {
  const code = currencyCode || getCurrentCurrency();
  const symbol = getCurrencySymbol(code);

  // Format number with proper decimal places
  const formatted = parseFloat(amount || 0).toFixed(2);

  // Different formatting for different currencies
  switch (code) {
    case 'PLN':
      return `${formatted} ${symbol}`;
    case 'EUR':
      return `${symbol}${formatted}`;
    case 'USD':
      return `${symbol}${formatted}`;
    default:
      return `${symbol}${formatted}`;
  }
};

// Listen for currency changes
export const onCurrencyChange = (callback) => {
  const handler = (event) => {
    callback(event.detail.currency);
  };

  window.addEventListener('currencyChanged', handler);

  // Return cleanup function
  return () => {
    window.removeEventListener('currencyChanged', handler);
  };
};